import React from 'react';
import {Button, Col, Label, Row} from 'reactstrap';
import {AvForm, AvGroup} from 'availity-reactstrap-validation';
import PropTypes from 'prop-types';
import GeneralUtils from "../../shared/utils/GeneralUtils";
import AvField from "../../shared/component/form/AvField";
import Translate from "../../shared/language/Translate";
import {
    PURCHASE_ORDER_STATUS,
    TILL_PRICE_CALCULATION_METHOD,
    TILL_PRICE_ITEM_CALCULATION_METHOD
} from "../../shared/utils/Constants";
import FormSection from "../../shared/component/form/FormSection";
import DateInput from "../../shared/component/form/DateInput";
import ModalConfirm from "../../shared/component/dialog/ModalConfirm";
import PurchaseOrderService from "../../shared/service/PurchaseOrderService";
import SupplierService from "../../shared/service/SupplierService";
import DataTableWithButton from "../../shared/component/dataTable/DataTableWithButton";
import PurchaseOrderItemColumn from "../../shared/component/dataTable/columns/PurchaseOrderItemColumn.json";
import PurchaseOrderItemMobileColumn from "../../shared/component/dataTable/columns/PurchaseOrderItemMobileColumn.json";
import PurchaseOrderItemResizableColumn
    from "../../shared/component/dataTable/columns/PurchaseOrderItemResizableColumn.json";

import Dialog from "../../shared/component/dialog/Dialog";
import PurchaseOrderItemSave from "./PurchaseOrderItemSave";
import {RadioButton} from "primereact/radiobutton";
import {AutoComplete} from "primereact/autocomplete";
import {toast} from "react-toastify";
import ProductService from "../../shared/service/ProductService";
import {FileUpload} from "primereact/fileupload";
import Loading from "../../shared/component/others/Loading";
import DepartmentService from "../../shared/service/DepartmentService";
import cloneDeep from 'lodash/cloneDeep';
import Decimal from "../storemanagement/decimal.mjs";
import {Checkbox} from "primereact/checkbox";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import SupplierFilter from "../storemanagement/SupplierFilter";
import NumberFormat from 'react-number-format';
import CalculationUtils from "../../shared/utils/CalculationUtils";
import MerchantUserService from "../../shared/service/MerchantUserService";
import MerchantBranchSettingsService from "../../shared/service/MerchantBranchSettingsService";
import '../../shared/styles/SettingsPage.css';

dayjs.extend(customParseFormat);

function toBackendLocalDateTime(value) {
    if (GeneralUtils.isNullOrEmpty(value) || value === 'Invalid Date') {
        return null;
    }
    let parsed = dayjs(value, 'DD/MM/YYYY', true);
    if (!parsed.isValid()) {
        parsed = dayjs(value);
    }
    return parsed.isValid() ? parsed.format('YYYY-MM-DDT00:00:00') : null;
}

const defaultLicense = {
    id: null,
    bssId: null,
    invoiceNumber: null,
    deliveryDate: null,
    invoiceDate: null,
    createDate: null,
    purchaseOrderStatus: 'INVOICE',
    invoiceType: "MANUAL_ENTRY",
    itemList: [],

    totalNet: null,
    totalAmount: null,
    totalTax: null,
    discountAmount: null,
    tillPriceCalculationMethod: "NEAREST_9",
    applyCurrentPriceFromBarcodeOnUpdate: false,
    printQueueTillUserBssId: null,

    supplierBssId: null,
    supplierName: null,
    supplierApproved: false,
    includeTax: false,
    useInvoiceBarcode: true,
    readBoxQuantityFromProduct: false,
    supplierAccountCode: null,
    supplierPhoneNumber: null,
    addressLine1: null,
    addressLine2: null,
    addressLine3: null,
    addressLine4: null,
    postcode: null,
    city: null,
    md5sum: null,
    totalFileCount: null,
    processedFileCount: null

};
const defaultItem = {
    id: null,
    bssId: null,

    // fixed
    barcode: null,
    productCode: null,
    generatedProductCode: null,
    itemName: null,
    boxUnitMeasure: null,       // this is not needed, included if needed later
    itemUnitMeasure: null,
    itemSize: null,
    taxRate: null,
    weighable: false,           // default is false

    // variable
    orderQuantity: null,
    deliveryQuantity: null,
    boxSize: null,
    unitPrice: null,
    totalPrice: null,
    taxPrice: null,
    discount: null,
    taxAmount: null,

    // optional / calculated / future fields
    itemBssId: null,
    salePrice: null,
    profitMargin: null,
    expiryDate: null,
    orjDescription: null,
    itemClosed: false,
    barcodeIsSearched: false,
    tillPriceCalculationMethod: null,
    newCodedProduct: false,
    printQueueTillUserBssId: null,
    maxOrjStock: null,
    maxStock: null,
    minStock: null,
    status: 'ACTIVE',
    priceMark: null,
    currentBoxPrice: null,
    currentBoxSize: null,
    currentUnitCost: null,
    importWarning: null
};

const INVOICE_TILL_PRICE_CALCULATION_METHOD = [
    ...TILL_PRICE_CALCULATION_METHOD,
    {name: 'CURRENT_PRICE', value: 'CURRENT_PRICE'}
];


export default class PurchaseOrderSave extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            license: Object.assign({}, defaultLicense),
            licenseTemp: Object.assign({}, defaultLicense),
            renderExtraDataDeleteButton: false,
            pageMode: null,
            purchaseOrderItemListFields:[],
            defaultCostPricePercentage: 0,
            filteredProducts: [],
            departmentList: [],
            tillUserList: [],
            filterOption: "all",
            supplierList: [],
            selectValue: 'Barcode',
            processButton: "process",
            /** true: büyüteç / satır seçimi; false: Process New veya Process Pending akışı */
            itemDialogOpenedFromItem: true,
            loading: false,
            first: 0,
            rows: 10,
            showCurrentPriceConfirmModal: false,
            pendingTillPriceCalculationMethod: null,
            tillPriceMethodSelectKey: 0,
        }
        this.purchaseOrderService = new PurchaseOrderService();
        this.supplierService = new SupplierService();
        this.productService = new ProductService();
        this.departmentService = new DepartmentService();
        this.merchantUserService = new MerchantUserService();
        this.merchantBranchSettingsService = new MerchantBranchSettingsService();
    }

    componentDidMount() {

        this.departmentService.findAll().then(response => this.setState({departmentList: response}));

        this.merchantUserService.getTillUsers(localStorage.getItem("merchantBranchId")).then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                this.setState({
                    tillUserList: response,
                });
            }

        });

        let id = window.location.href.split('?')[1];

        let invoiceType = window.location.href.split('?')[2];

        if (!GeneralUtils.__isValueEmpty(id) && id != "-1") {

            this.purchaseOrderService.findById(id).then(response => {
                    let responseObject = Object.assign({}, response);
                    let responseObjectTemp = Object.assign({}, response);
                    this.setState({
                        license: responseObject, licenseTemp: responseObjectTemp, licenseSaveButtonRender: true
                    });

                    if(response.invoiceNumber == "ERROR"){
                        this.setState({
                           licenseSaveButtonRender: false
                        });

                    }
                    else{
                        this.setState({
                            license: responseObject, licenseTemp: responseObjectTemp, licenseSaveButtonRender: true
                        }, () => {
                            const approved = this.checkSupplierApproved();
                            if (approved) {
                                const allEditButtons = document.querySelectorAll('.p-row-editor-init-icon');
                                if (this.state.license.purchaseOrderStatus != "CLOSED" && this.state.license.purchaseOrderStatus != "PARTIAL_CLOSED") {
                                    allEditButtons.forEach((btn) => {
                                        btn.click();
                                    });
                                }


                            }
                        });
                    }




                }
            );

        } else {
            let obj1 = Object.assign({}, defaultLicense, {invoiceType: invoiceType});


            obj1.itemList = [];
            this.setState({
                license: obj1,
                licenseSaveButtonRender: true,
                renderExtraDataDeleteButton: false,
                licenseTemp: Object.assign({}, obj1)
            }, () => {
            });

        }

        this.supplierService.findAll().then(response => this.setState({supplierList: response}));
        this.loadFields();
    }

    loadFields = () => {

        return this.merchantBranchSettingsService
            .findByBranchId(localStorage.getItem("merchantBranchId"))
            .then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.setState({
                        purchaseOrderItemListFields: response.purchaseOrderItemListFields,
                        defaultCostPricePercentage: response.defaultCostPricePercentage != null ? response.defaultCostPricePercentage : 0
                    });
                }
            });
    }

    renderImportCsv() {
        if (
            !GeneralUtils.isNullOrEmpty(this.state.license?.id) && this.state.license?.itemList.length == 0 &&
            this.state.license.invoiceType === "CSV"
        ) {
            return (
                <FormSection title={"Upload Csv Item List"}>
                    <div style={{display: "flex", alignItems: "center", gap: "5px"}}>
                        <FileUpload
                            name="csvFile"
                            accept=".csv"
                            maxFileSize={15000000}
                            onValidationFailError={GeneralUtils.onValidationFailErrorFile}
                            invalidFileSizeMessageDetail="Maximum upload size is 15MB."
                            chooseLabel="Choose CSV File"
                            disabled={false}
                            ref={(elem) => (this.refUploadInputCsv = elem)}
                            mode="basic"
                            style={{height: "30px"}}
                        />

                        <Button
                            color="outline-primary"
                            className="settings-page__btn--action"
                            onClick={() => this.importCsv(this.state.license.id)}
                        >
                            <Translate contentKey="entity.action.add">Upload CSV</Translate>
                        </Button>

                        <Button
                            color="outline-primary"
                            className="settings-page__btn--secondary settings-page__btn--wrap"
                            onClick={() => this.downloadCsvSample()}
                        >
                            <Translate contentKey="entity.action.add">Download CSV Sample</Translate>
                        </Button>
                    </div>
                </FormSection>
            );
        }
        return null;
    }

    renderUploadImage() {
        if (this.state.license.invoiceType == "UPLOAD" && GeneralUtils.isNullOrEmpty(this.state.license.id)) {
            return (
                <div>
                    <ModalConfirm
                        show={this.state.showDuplicateModal}
                        header="Confirm"
                        message={this.state.duplicateConfirmMessage}
                        onOkClick={() => {
                            if (this.state.duplicateConfirmAction) this.state.duplicateConfirmAction();
                            this.setState({
                                showDuplicateModal: false,
                                duplicateConfirmAction: null,
                                duplicateConfirmMessage: ""
                            });
                        }}
                        onCancelClick={() =>
                            this.setState({
                                showDuplicateModal: false,
                                duplicateConfirmAction: null,
                                duplicateConfirmMessage: ""
                            })
                        }
                        ok="Yes"
                        cancel="No"
                    />


                    <FormSection title={"Upload Invoice(s)"}>
                        <FileUpload
                            name="images"
                            maxFileSize={15000000}
                            onValidationFailError={GeneralUtils.onValidationFailErrorFile}
                            invalidFileSizeMessageDetail="Maximum upload size is 15MB."
                            chooseLabel={"Choose"}
                            multiple
                            disabled={false}
                            customUpload={true}
                            uploadHandler={this.handleCustomUpload}
                            ref={elem => this.refUploadInputImage = elem}
                            mode="advanced"
                        />


                    </FormSection>

                    <Button color="outline-primary" className="settings-page__btn--cancel settings-page__btn--back" onClick={() => {

                        let obj1 = Object.assign({}, defaultLicense);
                        obj1.itemList = [];
                        this.setState({
                            license: obj1,
                            licenseTemp: Object.assign({}, obj1)
                        }, () => {
                            window.location.href = "#purchaseOrder";
                        });


                    }}>
                        <Translate contentKey="entity.action.cancel">Back</Translate>
                    </Button>
                </div>
            );
        }
    }

    handleCustomUpload = async (event) => {
        this.setState({loading: true});
        const files = event.files;

        if (!GeneralUtils.isNullOrEmpty(files) && files.length > 0) {
            const formData = new FormData();

            for (let i = 0; i < files.length; i++) {
                formData.append("files", files[i]);
            }

            try {
                const checkResponse = await this.purchaseOrderService.checkSum5(formData);

                if (checkResponse === false) {
                    // ⚡ Duplicate fatura uyarısı için ayrı state kullanıyoruz
                    this.setState({
                        showDuplicateModal: true,
                        loading: false,
                        duplicateConfirmMessage: "This invoice has already been uploaded. Do you want to continue anyway?",
                        duplicateConfirmAction: async () => {
                            this.setState({showDuplicateModal: false, loading: true});

                            // Upload işlemini başlat
                            this.purchaseOrderService.uploadInvoiceDocument(formData)
                                .then(response => {
                                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                                        if (this.refUploadInputImage?.clear) {
                                            this.refUploadInputImage.clear();
                                        }

                                        setTimeout(() => {
                                            this.purchaseOrderService.findById(response.id).then(response => {
                                                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                                                    window.location.href = "#purchaseOrder";
                                                } else {
                                                    toast.warn("The uploaded image could not be processed. Please try uploading a different image");
                                                    window.location.href = "#purchaseOrder";
                                                }
                                            });
                                        }, 1000);
                                    }
                                })
                                .finally(() => this.setState({loading: false}));
                        }
                    });

                    return;
                }

                // ✅ Normal upload
                this.purchaseOrderService.uploadInvoiceDocument(formData)
                    .then(response => {
                        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                            if (this.refUploadInputImage?.clear) {
                                this.refUploadInputImage.clear();
                            }

                            setTimeout(() => {
                                this.purchaseOrderService.findById(response.id).then(response => {
                                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                                        window.location.href = "#purchaseOrder";
                                    } else {
                                        toast.warn("The uploaded image could not be processed. Please try uploading a different image");
                                        window.location.href = "#purchaseOrder";
                                    }
                                });
                            }, 1000);
                        }
                    })
                    .finally(() => this.setState({loading: false}));

            } catch (error) {
                console.error(error);
                toast.error("An error occurred while checking the invoice.");
                this.setState({loading: false});
            }

        } else {
            this.setState({loading: false});
            toast.warn("Please select at least one image.");
        }
    };


    renderPurchaseOrder() {
        const isMobile = GeneralUtils.isMobile();
        //halil
        const { license, filterOption } = this.state;
        const allItems = license?.itemList || [];
        const activeItems = allItems.filter(item => item.status === "ACTIVE");
        const duplicateItems = this.getDuplicateItems(activeItems);
        const duplicateItemIds = new Set(
            duplicateItems.map(item =>
                item.id != null ? `id:${item.id}` : `key:${item.barcode || ''}|${item.productCode || ''}`
            )
        );

        const filteredItems = allItems
            .filter(item => {
                const key =
                    item.id != null ? `id:${item.id}` : `key:${item.barcode || ''}|${item.productCode || ''}`;

                switch (filterOption) {
                    case 'productUnmatched':
                        return item.barcodeIsSearched !== true;

                    case 'priceUnmatched':
                        return item.oldPrice !== item.salePrice;

                    case 'productNew':
                        return item.barcodeIsSearched === true && item.itemBssId == null;

                    case 'duplicates':
                        return duplicateItemIds.has(key);

                    default:
                        return true;
                }
            })
            .map((item, index) => ({ ...this.calculateFields(item), _rowNo: index + 1 }));






        if ((this.state.license.invoiceType == "UPLOAD" && !GeneralUtils.isNullOrEmpty(this.state.license.id)) || this.state.license.invoiceType == "MANUAL_ENTRY" || this.state.license.invoiceType == "CSV") {


            return (
                <div>


                    <FormSection title={"Invoice Detail"}>


                        <ModalConfirm header='Warning' ok='OK' onOkClick={this.deleteInvoice}
                                      onCancelClick={() => this.setState({displayShowInvoiceDialog: false})}
                                      show={this.state.displayShowInvoiceDialog}
                                      message={this.state.noticeResponse}/>
                        <Row>

                            <Col md="3">
                                <AvGroup>
                                    <Label for="actionReason">
                                        <Translate contentKey="merchantBranch.actionReason">Status</Translate>
                                    </Label>
                                    <AvField
                                        type="select"
                                        className="form-control"
                                        name="purchaseOrderStatus"
                                        disabled={true}
                                        value={this.state.license.purchaseOrderStatus}
                                        onChange={this.__handleChange}>
                                        {PURCHASE_ORDER_STATUS.map(element => (
                                            <option value={element.value} key={element.value}>
                                                {element.name}
                                            </option>
                                        ))}
                                    </AvField>
                                </AvGroup>
                            </Col>

                            <Col md="3">
                                <AvGroup>
                                    <Label for="updateDate">
                                        <Translate
                                            contentKey="merchantBranch.updateDate">Invoice Date</Translate>
                                        <span style={{color: 'red'}}> (*)</span>
                                    </Label>

                                    <DateInput
                                        name="invoiceDate"
                                        onChange={this.__handleChange}
                                        format={"DD/MM/YYYY"}
                                        disabled={!(this.state.licenseSaveButtonRender && this.state.license.purchaseOrderStatus != "CLOSED" && this.state.license.purchaseOrderStatus != "PARTIAL_CLOSED")}
                                        value={this.state.license.invoiceDate}/>

                                </AvGroup>

                            </Col>

                            <Col md="3">
                                <AvGroup>
                                    <Label for="remainingDaysText">
                                        <Translate contentKey="merchantBranch.remainingDaysText">Invoice Number
                                        </Translate>
                                        <span style={{color: 'red'}}> (*)</span>
                                    </Label>
                                    <AvField
                                        type="text"
                                        className="form-control"
                                        name="invoiceNumber"
                                        disabled={!(this.state.licenseSaveButtonRender && this.state.license.purchaseOrderStatus != "CLOSED" && this.state.license.purchaseOrderStatus != "PARTIAL_CLOSED")}
                                        value={this.state.license.invoiceNumber}
                                        onChange={this.__handleChange}/>
                                </AvGroup>
                            </Col>


                        </Row>

                        <Row>

                            {this.renderSupplier()}


                        </Row>


                        <Row>
                            <Col md="3">
                                <AvGroup>
                                    <Label for="itemsTotalPrice">
                                        <Translate contentKey="merchantBranch.itemsTotalPrice">Items Total</Translate>
                                    </Label>
                                    <NumberFormat
                                        value={this.calculateItemsTotalPrice()}
                                        className={`number-format-input ${this.isDifferent(this.state.license) ? "highlight-text" : ""}`}
                                        thousandSeparator={true}
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                        prefix={'£'}
                                        disabled={true} // sadece okunur
                                    />
                                </AvGroup>
                            </Col>

                            <Col md="3">
                                <AvGroup>
                                    <Label for="totalProfit">
                                        <Translate contentKey="merchantBranch.totalProfit">Total Profit</Translate>
                                    </Label>
                                    <NumberFormat
                                        value={this.calculateTotalProfit()}
                                        className="number-format-input"
                                        thousandSeparator={true}
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                        prefix={'£'}
                                        disabled={true}
                                    />
                                </AvGroup>
                            </Col>

                            <Col md="3">
                                <AvGroup>
                                    <Label for="totalNet">
                                        <Translate contentKey="merchantBranch.totalNet">Invoice Subtotal</Translate>
                                        <span style={{color: 'red'}}> (*)</span>
                                    </Label>
                                    <NumberFormat
                                        value={this.state.license.totalNet}
                                        className="number-format-input"
                                        thousandSeparator={true}
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                        prefix={'£'}
                                        onValueChange={(values) => {
                                            this.setState(prev => ({
                                                license: {...prev.license, totalNet: values.value}
                                            }));
                                        }}
                                        disabled={!(this.state.licenseSaveButtonRender && this.state.license.purchaseOrderStatus != "CLOSED" && this.state.license.purchaseOrderStatus != "PARTIAL_CLOSED")}
                                    />
                                </AvGroup>
                            </Col>

                            <Col md="3">
                                <AvGroup>
                                    <Label for="totalAmount">
                                        <Translate contentKey="merchantBranch.totalAmount">Invoice Total</Translate>
                                        <span style={{color: 'red'}}> (*)</span>
                                    </Label>
                                    <NumberFormat
                                        value={this.state.license.totalAmount}
                                        className="number-format-input"
                                        thousandSeparator={true}
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                        prefix={'£'}
                                        onValueChange={(values) => {
                                            this.setState(prev => ({
                                                license: {...prev.license, totalAmount: values.value}
                                            }));
                                        }}
                                        disabled={!(this.state.licenseSaveButtonRender && this.state.license.purchaseOrderStatus != "CLOSED" && this.state.license.purchaseOrderStatus != "PARTIAL_CLOSED")}
                                    />
                                </AvGroup>
                            </Col>



                            { false && <Col md="3">
                                <AvGroup>
                                    <Label for="totalTax">
                                        <Translate contentKey="merchantBranch.totalTax">Tax Total</Translate>
                                    </Label>
                                    <NumberFormat
                                        value={this.state.license.totalTax}
                                        className="number-format-input"
                                        thousandSeparator={true}
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                        prefix={'£'}
                                        onValueChange={(values) => {
                                            this.setState(prev => ({
                                                license: {...prev.license, totalTax: values.value}
                                            }));
                                        }}
                                        disabled={!(this.state.licenseSaveButtonRender && this.state.license.purchaseOrderStatus != "CLOSED" && this.state.license.purchaseOrderStatus != "PARTIAL_CLOSED")}
                                    />
                                </AvGroup>
                            </Col>
                            }







                        </Row>


                        <FormSection title={"Items"}>

                            <Dialog visible={this.state.displayDialog}
                                    header={""}
                                    onHide={() => this.setState({displayDialog: false})}
                                    style={GeneralUtils.getDialogStyleForPurchaseOrder()}>

                                <PurchaseOrderItemSave ref={(elem) => this.refModelSave = elem}
                                                       refreshDataTable={this.refreshDataTable}
                                                       calculateFields={this.calculateFields}
                                                       deleteItemData={this.deleteItemData}
                                                       openNextItem={this.openNextItem}
                                                       updatePurchaseOrderItem={this.updatePurchaseOrderItem}
                                                       updatePurchaseOrderItemFieldsOnly={this.updatePurchaseOrderItemFieldsOnly}
                                                       updatePurchaseOrderItemAndNext={this.updatePurchaseOrderItemAndNext}
                                                       updatePurchaseOrderItemAndNextUnmatched={this.updatePurchaseOrderItemAndNextUnmatched}
                                                       closePurchaseOrderItemAndNext={this.closePurchaseOrderItemAndNext}
                                                       closePurchaseOrderItemAndNextUnmatched={this.closePurchaseOrderItemAndNextUnmatched}
                                                       closeDisplayDialog={this.closeDisplayDialog}
                                                       refreshOrderAndClose={this.refreshOrderAndClose}
                                                       isEditMode={this.state.licenseSaveButtonRender && this.checkSupplierApproved()}/>
                            </Dialog>


                            {this.renderSelectItems()}

                            {this.renderFilter()}
                            <DataTableWithButton
                                data={filteredItems}
                                purchaseOrderHighlight
                                key={this.state.licenseSaveButtonRender ? "edit" : "view"}
                                ref={(elem) => this.refDataTable = elem}
                                selectionMode="single"
                                paginator
                                rows={50}
                                className={`custom-datatable ${
                                    !isMobile && this.state.desktopScroll ? 'desktop-scroll' : ''
                                } ${
                                    !isMobile && this.state.desktopScroll ? 'purchase-order-items-table' : ''
                                }`}

                                scrollable={!isMobile && this.state.desktopScroll}
                                scrollDirection={!isMobile && this.state.desktopScroll ? "horizontal" : null}

                                editMode={
                                    !isMobile &&
                                    this.state.licenseSaveButtonRender &&
                                    this.checkSupplierApproved()
                                        ? "row"
                                        : null
                                }
                                dataKey={
                                    !isMobile &&
                                    this.state.licenseSaveButtonRender &&
                                    this.checkSupplierApproved()
                                        ? "id"
                                        : null
                                }

                                first={this.state.first}
                                onPage={(e) => {
                                    this.setState({ first: e.first, rows: e.rows }, () =>
                                        this.setAllRowsEditable()
                                    );
                                }}

                                search={this.searchByBarcode}
                                buttonDisabled={!this.state.licenseSaveButtonRender}
                                purchaseOrderStatus={this.state.license.purchaseOrderStatus}
                                select={this.onDataSelect}
                                setStateData={this.setStateData}
                                calculateFields={this.calculateFields}
                                checkSupplierApproved={this.checkSupplierApproved}
                                delete={this.showChangeStatusConfirmDialog}
                                fields={this.generatePurchaseOrderItemFields(this.state.departmentList)}
                                rowClassName={(rowData) => (rowData.shouldWarnUser === true ? { highlightTableRowLightRed: true } : {})}
                            />




                        </FormSection>


                        <div className="settings-page__actions settings-page__actions--equal-height">
                        {this.state.license.purchaseOrderStatus != "CLOSED" && !this.state.licenseSaveButtonRender && this.state.license.invoiceNumber != "ERROR" &&
                            <Button color="outline-primary" className="settings-page__btn--edit"
                                    onClick={() => {

                                        this.setState({
                                            licenseSaveButtonRender: true
                                        }, () => {
                                            this.setAllRowsEditable();
                                        });

                                    }}>
                                <Translate contentKey="entity.action.add">Edit</Translate>
                            </Button>}


                        {this.state.licenseSaveButtonRender && this.state.license.purchaseOrderStatus != "CLOSED" &&  this.state.license.invoiceNumber != "ERROR" &&
                            <Button color="outline-primary" className="settings-page__btn--save"
                                    onClick={() => {
                                        const approved = this.checkSupplierApproved();
                                        if (approved) {
                                            this.savePurchaseOrderItem(false);
                                        } else {
                                            return toast.warn("Please approve supplier to continue");
                                        }


                                    }}>
                                <Translate contentKey="entity.action.add">Save</Translate>
                            </Button>
                        }

                        {this.renderImportCsv()}


                        {!GeneralUtils.isNullOrEmpty(this.state.license.id) &&
                            this.state.license.purchaseOrderStatus !== "CLOSED" &&  this.state.license.invoiceNumber != "ERROR" &&

                            (() => {
                                const itemList = this.state.license.itemList || [];
                                const hasUnsearched = itemList.some(
                                    item => item.barcodeIsSearched && item.itemBssId == null && item.status === "ACTIVE"
                                );

                                if (hasUnsearched) {
                                    return (
                                        <Button
                                            color="outline-primary"
                                            className="settings-page__btn--action"
                                            onClick={() => {
                                                this.setState({
                                                    processButton: "new",
                                                });
                                                this.openFirstNewItem();
                                            }}
                                        >
                                            <Translate contentKey="entity.action.cancel">Process New</Translate>
                                        </Button>
                                    );
                                }
                                return null; // bu eklenmeli aksi halde undefined render hatası olur
                            })()}


                        {!GeneralUtils.isNullOrEmpty(this.state.license.id) &&
                            this.state.license.purchaseOrderStatus !== "CLOSED" &&  this.state.license.invoiceNumber != "ERROR" &&
                            (() => {
                                const itemList = this.state.license.itemList || [];
                                const hasUnsearched = itemList.some(item => !item.barcodeIsSearched && item.status === "ACTIVE");
                                const activeItemsForDup = itemList.filter(item => item.status === "ACTIVE");
                                const duplicateCount = this.getDuplicateItems(activeItemsForDup).length;

                                // 1) Her zaman önce pending/duplicate aksiyonları göster
                                if (hasUnsearched || duplicateCount > 0) {
                                    return (
                                        <>
                                            {hasUnsearched && (
                                                <Button
                                                    color="outline-primary"
                                                    className="settings-page__btn--action settings-page__btn--wrap"
                                                    onClick={() => {
                                                        this.setState({
                                                            processButton: "process",
                                                        });
                                                        this.openFirstUnsearchedItem();
                                                    }}
                                                >
                                                    <Translate contentKey="entity.action.cancel">Process Pending</Translate>
                                                </Button>
                                            )}

                                            {duplicateCount > 0 && (
                                                <Button
                                                    color="outline-danger"
                                                    className="settings-page__btn--delete settings-page__btn--wrap"
                                                    onClick={this.revertDuplicateItems}
                                                >
                                                    Revert Duplicates ({duplicateCount})
                                                </Button>
                                            )}
                                        </>
                                    );
                                } else {
                                    return (
                                        <>
                                            <Button
                                                color="outline-primary"
                                                className="settings-page__btn--save"
                                                onClick={() => {
                                                    this.confirmInvoice(true);
                                                }}
                                            >
                                                <Translate contentKey="entity.action.cancel">Confirm</Translate>
                                            </Button>


                                            <ModalConfirm
                                                show={this.state.showConfirmModal}
                                                header="Confirm"
                                                message={this.state.confirmMessage}
                                                onOkClick={() => {
                                                    if (this.state.confirmAction) this.state.confirmAction();
                                                    this.setState({
                                                        showConfirmModal: false,
                                                        confirmAction: null,
                                                        confirmMessage: ""
                                                    });
                                                }}
                                                onCancelClick={() =>
                                                    this.setState({
                                                        showConfirmModal: false,
                                                        confirmAction: null,
                                                        confirmMessage: ""
                                                    })
                                                }
                                                ok="Yes"
                                                cancel="No"
                                            />

                                        </>
                                    );
                                }
                            })()}


                        {!GeneralUtils.isNullOrEmpty(this.state.license.id) && (this.state.license.purchaseOrderStatus != "CLOSED" && this.state.license.purchaseOrderStatus != "PARTIAL_CLOSED") &&
                            <Button color="outline-danger" className="settings-page__btn--delete"
                                    onClick={() => {
                                        this.showInvoiceDeleteConfirmDialog()
                                    }}>
                                <Translate contentKey="entity.action.cancel">Delete</Translate>
                            </Button>}

                        <Button color="outline-primary" className="settings-page__btn--cancel settings-page__btn--back"
                                onClick={() => {
                                let obj1 = Object.assign({}, defaultLicense);
                                obj1.itemList = [];

                                this.setState({
                                    license: obj1,
                                    licenseTemp: Object.assign({}, obj1)
                                }, () => {
                                    window.location.href = "#purchaseOrder";

                                });

                            }}>
                        <Translate contentKey="entity.action.cancel">Back</Translate>
                    </Button>
                        </div>

                    </FormSection>
                </div>
            )

        }
    };

    openFirstNewItem = () => {
        const {license} = this.state;
        const itemList = license['itemList'] || [];

        if (this.checkSupplierApproved()) {
            const firstNewItem = itemList.find(item => item.barcodeIsSearched && item.itemBssId == null && item.status === "ACTIVE");

            if (firstNewItem) {
                this.onDataSelect(firstNewItem, false);

            } else {
                toast.info("No new items found.");
            }
        } else {
            toast.warn("Please approve supplier to continue");
        }


    };

    openFirstUnsearchedItem = () => {
        const {license} = this.state;
        const itemList = license['itemList'] || [];

        if (this.checkSupplierApproved()) {
            const firstUnsearched = itemList.find(item => !item.barcodeIsSearched && item.status === "ACTIVE");

            if (firstUnsearched) {
                this.onDataSelect(firstUnsearched, false);

            } else {
                toast.info("No unmatched items found.");
            }
        } else {
            toast.warn("Please approve supplier to continue");
        }


    };


    downloadCsvSample = async () => {
        const response = await this.purchaseOrderService.downloadCsvSample();

        if (response && response.file && response.fileName && response.fileType) {
            // Base64'ü arrayBuffer'a çevir
            const byteCharacters = atob(response.file);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);

            // Blob oluştur ve direkt indir
            const blob = new Blob([byteArray], {type: response.fileType});
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = response.fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            GeneralUtils.notification("CSV sample file not found!");
        }
    };


    checkSupplierApproved = () => {
        const {invoiceType, supplierApproved, supplierId} = this.state.license;
        //return !(invoiceType === "UPLOAD" && supplierApproved === false && supplierId == null);
        return !(invoiceType === "UPLOAD" && supplierApproved === false);
    };

    setAllRowsEditable = () => {
        try {
            const approved = this.checkSupplierApproved();
            if (approved) {
                const allEditButtons = document.querySelectorAll('.p-row-editor-init-icon');
                if (this.state.license.purchaseOrderStatus != "CLOSED" && this.state.license.purchaseOrderStatus != "PARTIAL_CLOSED") {
                    allEditButtons.forEach((btn) => {
                        btn.click();
                    });
                }


            } else {
                return toast.warn("Please approve supplier to continue");
            }


        } catch (e) {

        }


    };


    renderFilter() {
        const isMobile = GeneralUtils.isMobile();
        const itemList = this.state.license?.itemList || [];
        const filterCounts = this.getFilterCounts(itemList);

        const renderFilterOption = (inputId, value, label, count, warn = false) => (
            <div className="settings-page__po-item-filter" key={inputId}>
                <RadioButton
                    inputId={inputId}
                    name="filter"
                    value={value}
                    onChange={this.handleFilterChange}
                    checked={this.state.filterOption === value}
                />
                <label
                    htmlFor={inputId}
                    className={warn && count > 0 ? 'settings-page__po-item-filter--warn' : undefined}
                >
                    {label}{' '}
                    <span className="settings-page__po-item-filter-count">({count})</span>
                </label>
            </div>
        );

        return (
            <div className={`settings-page__po-item-filters${isMobile ? ' settings-page__po-item-filters--mobile' : ''}`}>
                {renderFilterOption('all', 'all', 'All', filterCounts.all)}
                {renderFilterOption('priceUnmatched', 'priceUnmatched', 'Updated Price', filterCounts.priceUnmatched)}
                {renderFilterOption('productUnmatched', 'productUnmatched', 'Pending', filterCounts.productUnmatched)}
                {renderFilterOption('productNew', 'productNew', 'New', filterCounts.productNew)}
                {renderFilterOption('duplicates', 'duplicates', 'Duplicates', filterCounts.duplicates, true)}

                {this.state.license.purchaseOrderStatus != "CLOSED" &&
                    this.state.license.purchaseOrderStatus != "PARTIAL_CLOSED" &&
                    !this.state.licenseSaveButtonRender &&
                    !GeneralUtils.isNullOrEmpty(this.state.license.id) &&
                    this.checkSupplierApproved() && (
                        <div className="settings-page__po-item-filters__action">
                            <Button
                                color="outline-primary"
                                className="settings-page__btn--add"
                                style={isMobile ? undefined : {minWidth: '10.5rem'}}
                                onClick={() => {
                                    const newItem = Object.assign({}, defaultItem);
                                    newItem.tillPriceCalculationMethod = 'MANUAL_ENTRY';
                                    this.onDataSelect(newItem, false);

                                }}
                            >
                                <Translate contentKey="entity.action.add">Add New Item</Translate>
                            </Button>
                        </div>
                    )}
            </div>
        );
    }


    handleFilterChange = (e) => {
        this.setState({filterOption: e.value}, () => {
        });
    };

    getFilterCounts = (itemList) => {
        const safeList = Array.isArray(itemList) ? itemList : [];
        const activeOnly = safeList.filter(item => item.status === "ACTIVE");

        return {
            all: safeList.length,
            productUnmatched: safeList.filter(item => item.barcodeIsSearched !== true).length,
            priceUnmatched: safeList.filter(item => item.oldPrice !== item.salePrice).length,
            productNew: safeList.filter(item => item.barcodeIsSearched === true && item.itemBssId == null).length,
            duplicates: this.getDuplicateItems(activeOnly).length
        };
    };

    /**
     * Aynı barcode'a sahip fakat farklı productCode'ları olan tüm item'ları döner.
     * Şimdilik sadece UI filtreleri ve şart kontrolleri için kullanılıyor.
     */
    getDuplicateItems = (itemList) => {
        const safeList = Array.isArray(itemList) ? itemList : [];
        const barcodeToProductCodes = new Map();
        const barcodeToItems = new Map();

        safeList.forEach(item => {
            if (!item || !item.barcode || !item.productCode) {
                return;
            }
            const barcode = item.barcode;
            const productCode = item.productCode;

            if (!barcodeToProductCodes.has(barcode)) {
                barcodeToProductCodes.set(barcode, new Set());
            }
            if (!barcodeToItems.has(barcode)) {
                barcodeToItems.set(barcode, []);
            }

            barcodeToProductCodes.get(barcode).add(productCode);
            barcodeToItems.get(barcode).push(item);
        });

        const duplicates = [];
        barcodeToProductCodes.forEach((productCodes, barcode) => {
            if (productCodes.size > 1) {
                const itemsForBarcode = barcodeToItems.get(barcode) || [];
                duplicates.push(...itemsForBarcode);
            }
        });

        return duplicates;
    };

    /**
     * Aynı barcode'a sahip fakat farklı productCode'ları olan item'lar için
     * revert işlemini tetikler. Backend'de invoice tekrar işlenir ve
     * güncel invoice DTO'su geri dönerek ekrandaki liste yenilenir.
     */
    revertDuplicateItems = () => {
        const license = this.state.license || {};
        const activeItems = (license.itemList || []).filter(item => item.status === "ACTIVE");
        const duplicateItems = this.getDuplicateItems(activeItems);
        const duplicatesCount = duplicateItems.length;

        if (GeneralUtils.isNullOrEmpty(license.id)) {
            return toast.warn("Please save the invoice before reverting items.");
        }

        if (duplicatesCount === 0) {
            return toast.info("No duplicate items found.");
        }

        this.setState({loading: true});
        this.purchaseOrderService.revertDuplicateItems(license.id)
            .then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.setState({
                        license: Object.assign({}, response),
                        licenseTemp: Object.assign({}, response),
                        loading: false
                    });
                } else {
                    this.setState({loading: false});
                }
            })
            .catch(() => {
                this.setState({loading: false});
            });
    };


    renderSelectItems() {
        if (this.state.license.purchaseOrderStatus != "CLOSED" && this.state.license.invoiceType == "MANUAL_ENTRY") {
            return (
                <div className="settings-page__po-select-product">
                    <FormSection title="Select Product">
                        <div className="settings-page__po-select-product-row">
                            <div className="settings-page__po-select-radios">
                                <div className="settings-page__radio-inline">
                                    <RadioButton
                                        disabled={!this.state.licenseSaveButtonRender}
                                        inputId="po-select-barcode"
                                        value="Barcode"
                                        onChange={(e) => this.setState({selectValue: e.value})}
                                        checked={this.state.selectValue === 'Barcode'}/>
                                    <label htmlFor="po-select-barcode">Barcode</label>
                                </div>
                                <div className="settings-page__radio-inline">
                                    <RadioButton
                                        disabled={!this.state.licenseSaveButtonRender}
                                        inputId="po-select-name"
                                        value="Name"
                                        onChange={(e) => this.setState({selectValue: e.value})}
                                        checked={this.state.selectValue === 'Name'}/>
                                    <label htmlFor="po-select-name">Name</label>
                                </div>
                            </div>

                            <div className="settings-page__po-select-field">
                                {this.state.selectValue === "Barcode" &&
                                    <AvGroup>
                                        <Label for="po-select-barcode-input">
                                            <Translate contentKey="productGroup.tradingName">Barcode</Translate>
                                        </Label>
                                        <AvField
                                            id="po-select-barcode-input"
                                            type="number"
                                            name="barcode"
                                            className="form-control"
                                            disabled={!this.state.licenseSaveButtonRender}
                                            max="99999999999999"
                                            onKeyDown={this._handleKeyDown}
                                            value={this.state.barcode}
                                            onChange={this.__handleChangeBarcode}/>
                                    </AvGroup>
                                }
                                {this.state.selectValue === "Name" &&
                                    <AvGroup>
                                        <Label for="po-select-name-input">
                                            <Translate contentKey="productGroup.tradingName">Name</Translate>
                                        </Label>
                                        <AutoComplete
                                            inputId="po-select-name-input"
                                            value={this.state.selectedProduct}
                                            suggestions={this.state.filteredProducts}
                                            completeMethod={this.searchProduct}
                                            onBlur={() => {
                                                setTimeout(() => {
                                                    this.setState({filteredProducts: []});
                                                }, 200);
                                            }}
                                            field="longname"
                                            disabled={!this.state.licenseSaveButtonRender}
                                            onChange={async (e) => {
                                                let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
                                                this.setState({selectedProduct: value});
                                                if (!GeneralUtils.isNullOrEmpty(e.value?.id)) {
                                                    const data = await this.convertToDto(e.value);
                                                    this.updatePurchaseOrderItem(data);
                                                }
                                            }}
                                        />
                                    </AvGroup>
                                }
                            </div>
                        </div>
                    </FormSection>
                </div>
            );
        }
    };


    onDataSelect = (data, isOpenFromItem) => {
        if (isOpenFromItem === undefined || isOpenFromItem === null) {
            isOpenFromItem = true;
        }
        const approved = this.checkSupplierApproved();
        if (approved) {
            const isEditMode = this.state.licenseSaveButtonRender && this.checkSupplierApproved();
            GeneralUtils.openDialogThenRef(this, {
                displayDialog: true,
                itemDialogOpenedFromItem: isOpenFromItem
            }, () => this.refModelSave, (ref) => {
                ref.setData(data, this.state.license.purchaseOrderStatus, this.state.license.invoiceType, isOpenFromItem, this.state.license.tillPriceCalculationMethod, this.state.license.printQueueTillUserBssId, isEditMode);
            });
        } else {
            return toast.warn("Please approve supplier to continue");
        }


    }

    __handleChangeBarcode = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        // Barcode alanında sadece rakam kabul et
        if (value != null) {
            value = value.toString().replace(/[^0-9]/g, '');
        }
        this.setState({barcode: value});
    }

    /**
     * Saves the given license to the server. Returns a Promise that resolves only on success.
     * State and dialog should be updated only after the server responds successfully.
     */
    saveLicenseToServer = (license, licenseSaveButtonRender) => {
        if (license.invoiceType === "MANUAL_ENTRY" && GeneralUtils.isNullOrEmpty(license.invoiceNumber)) {
            toast.warn("Invoice Number is required!");
            return Promise.reject(new Error("VALIDATION"));
        }
        if (license.invoiceType === "MANUAL_ENTRY" && GeneralUtils.isNullOrEmpty(license.supplierName)) {
            toast.warn("Supplier is required!");
            return Promise.reject(new Error("VALIDATION"));
        }
        if (license.invoiceType === "MANUAL_ENTRY" && GeneralUtils.isNullOrEmpty(license.invoiceDate)) {
            toast.warn("Invoice Date is required!");
            return Promise.reject(new Error("VALIDATION"));
        }
        if (license.invoiceType === "MANUAL_ENTRY" && GeneralUtils.isNullOrEmpty(license.totalNet)) {
            toast.warn("Invoice Subtotal is required!");
            return Promise.reject(new Error("VALIDATION"));
        }
        if (license.invoiceType === "MANUAL_ENTRY" && license.totalAmount == null) {
            toast.warn("Invoice Total is required!");
            return Promise.reject(new Error("VALIDATION"));
        }
        if (license.invoiceType == "CSV" && (GeneralUtils.isNullOrEmpty(license.invoiceNumber) || GeneralUtils.isNullOrEmpty(license.supplierName))) {
            toast.warn("Please fill the Invoice Number and Supplier fields!");
            return Promise.reject(new Error("VALIDATION"));
        }
        if (license.purchaseOrderStatus == "CLOSED" && (!license.itemList || license.itemList.length == 0)) {
            toast.warn("Please add item!");
            return Promise.reject(new Error("VALIDATION"));
        }

        const licenseToSave = { ...license };
        if (licenseToSave.applyCurrentPriceFromBarcodeOnUpdate == null) {
            licenseToSave.applyCurrentPriceFromBarcodeOnUpdate = false;
        }
        licenseToSave.deliveryDate = toBackendLocalDateTime(licenseToSave.deliveryDate);
        licenseToSave.invoiceDate = toBackendLocalDateTime(licenseToSave.invoiceDate);

        const apiCall = !GeneralUtils.isNullOrEmpty(licenseToSave.id)
            ? this.purchaseOrderService.update(licenseToSave)
            : this.purchaseOrderService.create(licenseToSave);

        return apiCall
            .then((response) => {
                if (GeneralUtils.isNullOrEmpty(response) || !GeneralUtils.isNullOrEmpty(response.type)) {
                    return Promise.reject(new Error("INVALID_RESPONSE"));
                }
                if (response.purchaseOrderStatus == "CLOSED") {
                    window.location.href = "#purchaseOrder";
                    return response;
                }
                this.setState({
                    licenseSaveButtonRender: licenseSaveButtonRender,
                    license: Object.assign({}, response),
                    licenseTemp: Object.assign({}, response)
                });
                return response;
            })
            .catch((err) => {
                toast.error("The request could not be sent to the server. Please try again.");
                return Promise.reject(err);
            });
    };

    savePurchaseOrderItem(licenseSaveButtonRender) {
        this.saveLicenseToServer(this.state.license, licenseSaveButtonRender).catch(() => {});
    }


    render() {
        return (
            <div className="settings-page settings-page--full col-md-12">
                <AvForm autocomplete="off">
                    <div className="settings-page__shell">
                        <div className="settings-page__panel">
                            {this.renderUploadImage()}
                            {this.renderPurchaseOrder()}
                        </div>
                    </div>
                </AvForm>

                <ModalConfirm
                    show={this.state.showCurrentPriceConfirmModal}
                    header="Confirm"
                    message="The prices of items in your invoice will be updated with the current prices. Do you want to continue?"
                    onOkClick={this.confirmCurrentPriceSelection}
                    onCancelClick={this.cancelCurrentPriceSelection}
                    ok="Yes"
                    cancel="No"
                />

                {this.state.loading && <Loading label="Processing, please wait..."/>}
            </div>
        );
    }

    setChecked = (name, value) => {
        let license = {...this.state.license}; // kopya al
        license[name] = value;

        this.setState({license}, () => {
            const updatedItemList = (this.state.license.itemList || []).map(item =>
                this.calculateFields({...item})
            );

            // hesaplanan listeyi tekrar state'e yaz
            this.setState(prevState => ({
                license: {
                    ...prevState.license,
                    itemList: updatedItemList
                }
            }));
        });


    };

    isDifferent() {
        let license = this.state.license;
        const licenseAmount = new Decimal(license?.totalAmount || 0).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
        const licenseNet = new Decimal(license?.totalNet || 0).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
        const itemsTotal = new Decimal(this.calculateItemsTotalPrice(license) || 0)
            .toDecimalPlaces(2, Decimal.ROUND_HALF_UP);

        if (license?.includeTax) {
            return !itemsTotal.equals(licenseAmount);
        } else {
            return !itemsTotal.equals(licenseNet);
        }
    }

    getActiveItems = (license = this.state.license) => {
        const items = Array.isArray(license?.itemList) ? license.itemList : [];
        return items.filter(item => item.status === "ACTIVE");
    };

    calculateItemsTotalPrice = (license = this.state.license) => {
        const itemList = Array.isArray(license?.itemList) ? license.itemList : [];
        return itemList.reduce((sum, item) => sum + (parseFloat(item.totalPrice) || 0), 0);
    };

    calculateTotalProfit = (license = this.state.license) => {
        return this.getActiveItems(license)
            .reduce((sum, item) => {
                const boxSize = parseFloat(item.boxSize) || 1;
                const deliveryQty = parseFloat(item.deliveryQuantity) || 1;
                const unitCost = parseFloat(item.unitCost) || 0;
                const salePrice = parseFloat(item.salePrice) || 0;
                const profitPerUnit = salePrice - unitCost;
                return sum + (profitPerUnit * deliveryQty * boxSize);
            }, 0);
    };


    setStateData = (data) => {
        const license = this.state.license;
        const existingList = Array.isArray(license.itemList) ? [...license.itemList] : [];
        const updatedList = Array.isArray(data) ? data : [];

        const isSameItem = (left, right) => {
            if (!left || !right) return false;
            if (left.id != null && right.id != null) {
                return left.id === right.id;
            }
            if (left.barcode && right.barcode) {
                return left.barcode === right.barcode;
            }
            return false;
        };

        const mergedList = existingList.map((item) => {
            const updatedItem = updatedList.find((candidate) => isSameItem(item, candidate));
            return updatedItem ? {...item, ...updatedItem} : item;
        });

        updatedList.forEach((item) => {
            const exists = mergedList.some((candidate) => isSameItem(candidate, item));
            if (!exists) {
                mergedList.push(item);
            }
        });

        this.setState({
            license: {
                ...license,
                itemList: mergedList
            }
        });


    }


    refreshDataTable = () => {
        this.closeDisplayDialog();
        this.refDataTable.refresh();
    }


    deleteInvoice = (data) => {
        if (!GeneralUtils.isNullOrEmpty(this.state.license.id)) {
            this.purchaseOrderService.delete(this.state.license.id)
                .then((response) => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        window.location.href = "#purchaseOrder";
                    }


                });
        }
    }
    deleteItemData = () => {
        const {license} = this.state;

        if (license.purchaseOrderStatus !== "CLOSED") {
            const deleteId = this.refModelSave.getDeleteId();
            if (!deleteId) return;

            const updatedItemList = license.itemList.filter(item => item.id !== deleteId);
            const updatedLicense = { ...license, itemList: updatedItemList };

            this.saveLicenseToServer(updatedLicense, true)
                .then(() => this.closeDisplayDialog())
                .catch(() => {});
        }
    }


    convertToDto = async (response) => {
        const data = {
            itemBssId: response.bssId,
            barcode: response.barcode,
            itemName: response.name,
            itemSize: response.quantity,
            taxRate: response.taxRate ?? response.departmentTaxRate,
            weighable: response.weighable,
            deliveryQuantity: 1,
            boxPrice: response.costPrice,
            oldPrice: response.price,
            currentBoxPrice: response.costPrice,
            currentBoxSize: (response.boxQuantity != null && response.boxQuantity !== 0) ? response.boxQuantity : null,
            status: "ACTIVE",
            barcodeType: response.barcodeType,
            barcodeDigit: response.barcodeDigit,
            codeLength: response.codeLength,
            salePrice: null,
            profitMargin: response.profitMargin,
            recommendedSalePrice: response.recommendedSalePrice,
            itemUnitMeasure: response.unit,
            boxUnitMeasure: response.boxUnit,
            departmentId: response.departmentId,
            barcodeIsSearched: true,
            tillPriceCalculationMethod: this.state.license.tillPriceCalculationMethod
        };

        // boxSize sadece 0 veya 1 değilse ata
        if (response.boxQuantity != null && response.boxQuantity !== 0 && response.boxQuantity !== 1) {
            data.boxSize = response.boxQuantity;
        } else if (data.boxSize == null && response.boxQuantity != null) {
            data.boxSize = response.boxQuantity;
        }

        // minStock
        if (response.minStock != null && response.minStock !== 0) {
            data.minStock = response.minStock;
        } else {
            data.minStock = await this.getDefaultMinStock();
        }

        // maxStock
        if (response.maxStock != null && response.maxStock !== 0) {
            data.maxStock = response.maxStock;
            data.maxOrjStock = response.maxStock;
        }

        return data;
    };


    convertProductDTOToItemDto = async (data, response) => {
        data.itemBssId = response.bssId;
        data.departmentId = response.departmentId;
        data.taxRate = (response.taxRate ?? response.departmentTaxRate);
        data.oldPrice = response.price;
        data.currentBoxPrice = response.costPrice;
        data.currentBoxSize = (response.boxQuantity != null && response.boxQuantity !== 0) ? response.boxQuantity : null;
        data.status = "ACTIVE";
        data.barcodeType = response.barcodeType;
        data.barcodeDigit = response.barcodeDigit;
        data.codeLength = response.codeLength;
        data.itemName = response.name;
        data.itemSize = response.quantity;
        data.itemUnitMeasure = response.unit;
        // boxSize sadece 0 veya 1 değilse ata
        if (response.boxQuantity != null && response.boxQuantity !== 0 && response.boxQuantity !== 1) {
            data.boxSize = response.boxQuantity;
        } else if (data.boxSize == null && response.boxQuantity != null) {
            data.boxSize = response.boxQuantity;
        }

        data.boxUnitMeasure = response.boxUnit;


        data.profitMargin = (response.profitMargin != null && response.profitMargin !== 0 && response.profitMargin !== 40)
            ? response.profitMargin
            : ((response.departmentProfitMargin != null && response.departmentProfitMargin !== 0 && response.departmentProfitMargin !== 40)
                ? response.departmentProfitMargin
                : await this.getDefaultProfitMargin());

        data.weighable = response.weighable;
        if (response.minStock != null && response.minStock !== 0) {
            data.minStock = response.minStock;
        } else {
            data.minStock = await this.getDefaultMinStock();
        }

        if (response.maxStock != null && response.maxStock !== 0) {
            data.maxStock = response.maxStock;
            data.maxOrjStock = response.maxStock;
        } else {
            data.maxOrjStock = null;
        }

        data.barcodeIsSearched = true;


        return data;


    }
    getDefaultProfitMargin = () => {
        return this.merchantBranchSettingsService
            .findByBranchId(localStorage.getItem("merchantBranchId"))
            .then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    return response.profitMargin?? 40;
                }
                return 40;
            });
    };
    getDefaultMinStock = () => {
        return this.merchantBranchSettingsService
            .findByBranchId(localStorage.getItem("merchantBranchId"))
            .then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    return response.minStock ?? null; // response.minStock varsa al, yoksa null
                }
                return null;
            });
    };
    /** Listeyi güncelle - save/close yapmadan (barcode search sonrası sync için) */
    updatePurchaseOrderItemFieldsOnly = (data) => {
        let license = this.state.license;
        const updatedItemList = [...(license['itemList'] || [])];
        let existingIndex = updatedItemList.findIndex(item => item.id === data.id);
        if (existingIndex == -1) {
            existingIndex = updatedItemList.findIndex(item => item.barcode === data.barcode);
        }
        if (existingIndex !== -1) {
            updatedItemList[existingIndex] = {...updatedItemList[existingIndex], ...data};
        }
        this.setState({ license: { ...license, itemList: updatedItemList } });
    };

    /** Yeni item (id yok): item'ı itemList'e ekleyip PO'yu backend update ile gönderir, dialog kapatılır. */
    saveNewItemAndClose = (itemData) => {
        const license = this.state.license;
        const updatedItemList = [...(license.itemList || [])];
        updatedItemList.push({...itemData, status: itemData.status || 'ACTIVE', shouldWarnUser: itemData.shouldWarnUser === true});
        const updatedLicense = {...license, itemList: updatedItemList};
        this.saveLicenseToServer(updatedLicense, true)
            .then(() => this.closeDisplayDialog())
            .catch(() => {});
    };

    /** Item'ı backend'e tek tek gönderir; başarıda listeyi DB'den çekip ekranda son hali gösterilir. */
    updatePurchaseOrderItem = (data) => {
        if (GeneralUtils.isNullOrEmpty(data?.id)) {
            this.saveNewItemAndClose(data);
            return;
        }
        const licenseId = this.state.license?.id;
        if (GeneralUtils.isNullOrEmpty(licenseId)) {
            return;
        }
        this.purchaseOrderService.updateItems(data)
            .then((itemResponse) => {
                if (GeneralUtils.isNullOrEmpty(itemResponse) || !GeneralUtils.isNullOrEmpty(itemResponse.type)) {
                    return;
                }
                return this.purchaseOrderService.findById(licenseId);
            })
            .then((freshLicense) => {
                if (GeneralUtils.isNullOrEmpty(freshLicense) || !GeneralUtils.isNullOrEmpty(freshLicense.type)) {
                    return;
                }
                this.setState({
                    license: Object.assign({}, freshLicense),
                    licenseTemp: Object.assign({}, freshLicense)
                }, () => this.closeDisplayDialog());
            })
            .catch(() => {});
    }

    closePurchaseOrderItemAndNextUnmatched = (data) => {
        if (this.state.processButton == "new") {
            let license = this.state.license;
            const updatedItemList = license['itemList'];

            // 🔹 Sadece aktif ürünleri filtrele
            //const activeItems = updatedItemList.filter(item => item.status === "ACTIVE");
            const activeItems = updatedItemList;

            // 🔹 id veya barcode ile aktif listede mevcut item'ı bul
            let existingIndex = activeItems.findIndex(item => item.id === data.id);
            if (existingIndex === -1) {
                existingIndex = activeItems.findIndex(item => item.barcode === data.barcode);
            }

            if (existingIndex !== -1) {
                const globalIndex = updatedItemList.findIndex(item => item.id === activeItems[existingIndex].id);
                updatedItemList[globalIndex] = {...updatedItemList[globalIndex], ...data};
            } else {
                updatedItemList.push(data);
            }

            license['itemList'] = updatedItemList;

            this.setState({license}, () => {

                // sıradaki aktif item’lerden barcodeIsSearched == true && itemBssId == null olanı bul
                const nextNew = activeItems
                    .slice(existingIndex + 1)
                    .find(item => item.barcodeIsSearched === true && item.itemBssId == null);

                if (nextNew) {
                    this.onDataSelect(nextNew, false);
                } else {
                    this.closeDisplayDialog();
                }
            });
        } else {
            let license = this.state.license;
            const updatedItemList = license['itemList'];
            //const activeItems = updatedItemList.filter(item => item.status === "ACTIVE");
            const activeItems = updatedItemList;

            let existingIndex = activeItems.findIndex(item => item.id === data.id);
            if (existingIndex === -1) {
                existingIndex = activeItems.findIndex(item => item.barcode === data.barcode);
            }

            if (existingIndex !== -1) {
                const globalIndex = updatedItemList.findIndex(item => item.id === activeItems[existingIndex].id);
                updatedItemList[globalIndex] = {...updatedItemList[globalIndex], ...data};
            } else {
                updatedItemList.push(data);
            }

            license['itemList'] = updatedItemList;

            this.setState({license}, () => {

                const nextUnmatched = activeItems
                    .slice(existingIndex + 1)
                    .find(item => item.barcodeIsSearched === false || item.barcodeIsSearched == null);

                if (nextUnmatched) {
                    this.onDataSelect(nextUnmatched, false);
                } else {
                    this.closeDisplayDialog();
                }
            });
        }
    };

    openNextItem = (data) => {
        let license = this.state.license;
        const updatedItemList = license['itemList'];
        const activeItems = updatedItemList;
        const { processButton, itemDialogOpenedFromItem } = this.state;

        let existingIndex = activeItems.findIndex(item => item.id === data.id);

        if (existingIndex !== -1) {
            const globalIndex = updatedItemList.findIndex(item => item.id === activeItems[existingIndex].id);
            updatedItemList[globalIndex] = {...updatedItemList[globalIndex], ...data};
        } else {
            updatedItemList.push(data);
        }

        license['itemList'] = updatedItemList;

        this.setState({license}, () => {

            if (itemDialogOpenedFromItem) {
                const nextIndex = existingIndex + 1;
                if (nextIndex < activeItems.length) {
                    this.onDataSelect(activeItems[nextIndex], true);
                } else {
                    this.closeDisplayDialog();
                }
                return;
            }

            let nextRow = null;
            if (processButton === "new") {
                nextRow = activeItems
                    .slice(existingIndex + 1)
                    .find(item => item.barcodeIsSearched === true && item.itemBssId == null);
            } else {
                nextRow = activeItems
                    .slice(existingIndex + 1)
                    .find(item => item.barcodeIsSearched === false || item.barcodeIsSearched == null);
            }

            if (nextRow) {
                this.onDataSelect(nextRow, false);
            } else {
                this.closeDisplayDialog();
            }
        });
    };

    closePurchaseOrderItemAndNext = (data) => {
        let license = this.state.license;
        const updatedItemList = license['itemList'];

        // 🔹 Sadece aktif ürünleri filtrele
        //const activeItems = updatedItemList.filter(item => item.status === "ACTIVE");
        const activeItems = updatedItemList;

        // 🔹 id veya barcode ile aktif listede mevcut item'ı bul
        let existingIndex = activeItems.findIndex(item => item.id === data.id);
        if (existingIndex === -1) {
            existingIndex = activeItems.findIndex(item => item.barcode === data.barcode);
        }

        if (existingIndex !== -1) {
            const globalIndex = updatedItemList.findIndex(item => item.id === activeItems[existingIndex].id);
            updatedItemList[globalIndex] = {...updatedItemList[globalIndex], ...data};
        } else {
            updatedItemList.push(data);
        }

        license['itemList'] = updatedItemList;

        this.setState({license}, () => {

            const nextIndex = existingIndex + 1;
            if (nextIndex < activeItems.length) {
                this.onDataSelect(activeItems[nextIndex], true);
            } else {
                this.closeDisplayDialog();
            }
        });
    };

    /** Item'ı backend'e tek tek gönderir; başarıda listeyi DB'den çekip sıradaki unmatched item'a geçer. */
    updatePurchaseOrderItemAndNextUnmatched = (data) => {
        if (GeneralUtils.isNullOrEmpty(data?.id)) {
            this.saveNewItemAndClose(data);
            return;
        }
        const { license, processButton } = this.state;
        const licenseId = license?.id;
        if (GeneralUtils.isNullOrEmpty(licenseId)) {
            return;
        }
        this.purchaseOrderService.updateItems(data)
            .then((itemResponse) => {
                if (GeneralUtils.isNullOrEmpty(itemResponse) || !GeneralUtils.isNullOrEmpty(itemResponse.type)) {
                    return;
                }
                return this.purchaseOrderService.findById(licenseId);
            })
            .then((freshLicense) => {
                if (GeneralUtils.isNullOrEmpty(freshLicense) || !GeneralUtils.isNullOrEmpty(freshLicense.type)) {
                    return;
                }
                const activeItems = freshLicense.itemList || [];
                const idx = activeItems.findIndex(item => item.id === data.id) >= 0
                    ? activeItems.findIndex(item => item.id === data.id)
                    : activeItems.findIndex(item => item.barcode === data.barcode);
                let nextItem = null;
                if (processButton == "new") {
                    nextItem = activeItems
                        .slice(idx + 1)
                        .find(item => item.barcodeIsSearched === true && item.itemBssId == null);
                } else {
                    nextItem = activeItems
                        .slice(idx + 1)
                        .find(item => item.barcodeIsSearched === false || item.barcodeIsSearched == null);
                }
                this.setState({
                    license: Object.assign({}, freshLicense),
                    licenseTemp: Object.assign({}, freshLicense)
                }, () => {
                    if (nextItem) {
                        this.onDataSelect(nextItem, false);
                    } else {
                        this.closeDisplayDialog();
                    }
                });
            })
            .catch(() => {});
    };

    /** Item'ı backend'e tek tek gönderir; başarıda listeyi DB'den çekip sıradaki item'a geçer. */
    updatePurchaseOrderItemAndNext = (data) => {
        if (GeneralUtils.isNullOrEmpty(data?.id)) {
            this.saveNewItemAndClose(data);
            return;
        }
        const { license } = this.state;
        const licenseId = license?.id;
        if (GeneralUtils.isNullOrEmpty(licenseId)) {
            return;
        }
        this.purchaseOrderService.updateItems(data)
            .then((itemResponse) => {
                if (GeneralUtils.isNullOrEmpty(itemResponse) || !GeneralUtils.isNullOrEmpty(itemResponse.type)) {
                    return;
                }
                return this.purchaseOrderService.findById(licenseId);
            })
            .then((freshLicense) => {
                if (GeneralUtils.isNullOrEmpty(freshLicense) || !GeneralUtils.isNullOrEmpty(freshLicense.type)) {
                    return;
                }
                const activeItems = freshLicense.itemList || [];
                const idx = activeItems.findIndex(item => item.id === data.id) >= 0
                    ? activeItems.findIndex(item => item.id === data.id)
                    : activeItems.findIndex(item => item.barcode === data.barcode);
                const nextItem = activeItems[idx + 1];
                this.setState({
                    license: Object.assign({}, freshLicense),
                    licenseTemp: Object.assign({}, freshLicense)
                }, () => {
                    if (nextItem) {
                        this.onDataSelect(nextItem, true);
                    } else {
                        this.closeDisplayDialog();
                    }
                });
            })
            .catch(() => {});
    };


    closeDisplayDialog = () => {
        this.setState({displayDialog: false});
    }

    /** Sadece order'ı DB'den çekip listeyi günceller ve dialog'u kapatır (conflict'te başka item seçildiğinde revert'i ezmemek için). */
    refreshOrderAndClose = () => {
        const licenseId = this.state.license?.id;
        if (GeneralUtils.isNullOrEmpty(licenseId)) {
            this.closeDisplayDialog();
            return;
        }
        this.purchaseOrderService.findById(licenseId)
            .then((freshLicense) => {
                if (GeneralUtils.isNullOrEmpty(freshLicense) || !GeneralUtils.isNullOrEmpty(freshLicense.type)) {
                    this.closeDisplayDialog();
                    return;
                }
                this.setState({
                    license: Object.assign({}, freshLicense),
                    licenseTemp: Object.assign({}, freshLicense)
                }, () => this.closeDisplayDialog());
            })
            .catch(() => this.closeDisplayDialog());
    }


    licenseSaveButtonRender = () => {
        this.setState({licenseSaveButtonRender: true});
    }

    setData = (data) => {
        this.setState({
            license: data,
            licenseTemp: Object.assign({}, data),
            licenseSaveButtonRender: false,
            renderExtraDataDeleteButton: false
        });

    }


    confirmInvoice = (fullConfirmInvoice) => {
        if (!GeneralUtils.isNullOrEmpty(this.state.license.id)) {
            if (this.state.license.purchaseOrderStatus != "CLOSED" && this.state.license.itemList.length == 0) {
                return toast.warn("Please add item!");
            } else {
                const itemList = this.state.license.itemList;
                let checkfields = false;
                let message = "";

                const missingFields = [];

                if (GeneralUtils.isNullOrEmpty(this.state.license.invoiceNumber)) {
                    missingFields.push("Invoice Number");
                }
                if (GeneralUtils.isNullOrEmpty(this.state.license.supplierName)) {
                    missingFields.push("Supplier");
                }
                if (GeneralUtils.isNullOrEmpty(this.state.license.invoiceDate)) {
                    missingFields.push("Invoice Date");
                }
                if (GeneralUtils.isNullOrEmpty(this.state.license.totalNet)) {
                    missingFields.push("Invoice Subtotal");
                }
                if (this.state.license.totalAmount == null) {
                    missingFields.push("Invoice total");
                }

                if (missingFields.length > 0) {
                    return toast.warn(`Please fill the required fields: ${missingFields.join(", ")}`);
                }

                const fieldsMeta = {
                    barcode: "Barcode",
                    itemName: "Name",
                    itemSize: "Item Size",
                    itemUnitMeasure: "Unit Measure",
                    taxRate: "Tax Rate",
                    totalPrice: "Total Cost",
                    deliveryQuantity: "Delivery Qty",
                    boxPrice: "Box Cost",
                    boxSize: "Box Qty",
                    profitMargin: "Profit Margin",
                    salePrice: "Sale Price",
                    departmentId: "Department"
                };

                // 🔹 Ana fonksiyon — invoice'ı kapatır
                const closeInvoice = () => {
                    let license = this.state.license;
                    license['purchaseOrderStatus'] = fullConfirmInvoice === true ? "CLOSED" : "PARTIAL_CLOSED";
                    this.setState({license}, () => this.savePurchaseOrderItem(false));
                };

                if (fullConfirmInvoice) {
                    const inactiveItems = itemList.filter(item => item.status !== "ACTIVE");
                    const activeItems = itemList.filter(item => item.status === "ACTIVE");

                    // 🔹 Önce ACTIVE item'ları kontrol et
                    for (const item of activeItems) {
                        if (item.barcodeIsSearched === false || item.barcodeIsSearched == null) {
                            message = `This barcode '${item.itemName}' has not been searched.`;
                            checkfields = true;
                            break;
                        }

                        for (const field in fieldsMeta) {
                            if (field === "taxRate") {
                                if (item[field] == null) {
                                    message = `Please fill the field '${fieldsMeta[field]}' for item: '${item.itemName}'.`;
                                    checkfields = true;
                                    break;
                                }
                            } else {
                                if (GeneralUtils.isNullOrEmpty(item[field])) {
                                    message = `Please fill the field '${fieldsMeta[field]}' for item: '${item.itemName}'.`;
                                    checkfields = true;
                                    break;
                                }
                            }
                        }
                        if (checkfields) break;
                    }

                    // 🔹 Eğer eksik yoksa ama pasif kayıt varsa kullanıcıya sor
                    if (!checkfields && inactiveItems.length > 0) {
                        const inactiveCount = inactiveItems.length;
                        const inactiveNames =
                            inactiveItems
                                .slice(0, 5)
                                .map(i => i.itemName)
                                .join(", ") + (inactiveCount > 5 ? "..." : "");

                        const confirmMessage = `There are ${inactiveCount} ignored items (${inactiveNames}). Do you still want to continue?`;

                        this.setState({
                            showConfirmModal: true,
                            confirmMessage,
                            confirmAction: () => {
                                // ✅ Artık tekrar confirmInvoice çağırmıyoruz
                                // doğrudan invoice işlemini tamamlıyoruz
                                this.setState({showConfirmModal: false}, closeInvoice);
                            }
                        });

                        return; // durdur, kullanıcı kararı bekle
                    }
                } else {
                    // PARTIAL confirm: sadece barcode doluysa diğer alanlara bak
                    for (const item of itemList) {
                        if (GeneralUtils.isNullOrEmpty(item.barcode)) continue;

                        for (const field in fieldsMeta) {
                            if (field === "barcode") continue;

                            if (field === "taxRate") {
                                if (item[field] == null) {
                                    message = `Please fill the field '${fieldsMeta[field]}' for item: '${item.itemName}'.`;
                                    checkfields = true;
                                    break;
                                }
                            } else {
                                if (GeneralUtils.isNullOrEmpty(item[field])) {
                                    message = `Please fill the field '${fieldsMeta[field]}' for item: '${item.itemName}'.`;
                                    checkfields = true;
                                    break;
                                }
                            }
                        }
                        if (checkfields) break;
                    }
                }

                if (checkfields) {
                    return toast.warn(message);
                }

                // 🔹 Fiyat eşleşme kontrolü
                let totalCostDecimal = new Decimal(0);
                for (const item of itemList.filter(item => item.status === "ACTIVE")) {
                    totalCostDecimal = totalCostDecimal.plus(new Decimal(item.totalPrice || 0));
                }

                totalCostDecimal = totalCostDecimal.toDecimalPlaces(2, Decimal.ROUND_HALF_UP);

                const licenseAmount = new Decimal(this.state.license?.totalAmount || 0).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
                const licenseNet = new Decimal(this.state.license?.totalNet || 0).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);

                let needsConfirmation = false;
                let confirmMessage = "";

                if (this.state.license?.includeTax) {
                    if (!totalCostDecimal.equals(licenseAmount)) {
                        needsConfirmation = true;
                        confirmMessage = `Invoice Total (£${licenseAmount}) and items Total (£${totalCostDecimal}) are different! Are you sure to continue?`;
                    }
                } else {
                    if (!totalCostDecimal.equals(licenseNet)) {
                        needsConfirmation = true;
                        confirmMessage = `Invoice Subtotal (£${licenseNet}) and items Total (£${totalCostDecimal}) are different! Are you sure to continue?`;
                    }
                }

                if (needsConfirmation) {
                    this.setState({
                        showConfirmModal: true,
                        confirmMessage,
                        confirmAction: closeInvoice
                    });
                } else {
                    closeInvoice();
                }
            }
        }
    };

    showInvoiceDeleteConfirmDialog = () => {
        this.setState({
            displayShowInvoiceDialog: true,
            noticeResponse: "Are you sure to delete invoice?",
        });
    }

    clearData = () => {
        let obj = Object.assign({}, defaultLicense);
        this.setState({license: obj, renderExtraDataDeleteButton: false});
    }


    __handleChange = async (e) => {
        const {name, value: rawValue, parsedValue} = e.target;
        const value = parsedValue !== undefined ? parsedValue : rawValue;

        if (name == "tillPriceCalculationMethod") {
            if (value === "CURRENT_PRICE") {
                this.setState({
                    showCurrentPriceConfirmModal: true,
                    pendingTillPriceCalculationMethod: value
                });
                return;
            }
            let license = {...this.state.license}; // kopya al
            license[name] = value;

            this.setState({license}, () => {
                const updatedItemList = (license.itemList || []).map(item => {
                    // item = { ...item, tillPriceCalculationMethod: value };
                    return this.calculateFields(item);
                });

                this.setState(prevState => ({
                    license: {
                        ...prevState.license,
                        itemList: updatedItemList
                    }
                }));
            });
        } else {
            this.setState(prev => {
                let updatedLicense = {
                    ...prev.license,
                    [name]: value,
                    ...(name === "barcode"
                        ? {
                            barcodeIsSearched: false,
                            ItemBssId: null
                        }
                        : {})

                };

                return {license: updatedLicense};
            });
        }
    };

    confirmCurrentPriceSelection = async () => {
        const value = this.state.pendingTillPriceCalculationMethod || "CURRENT_PRICE";
        this.setState({
            showCurrentPriceConfirmModal: false,
            pendingTillPriceCalculationMethod: null
        });

        const approved = this.checkSupplierApproved();
        if (!approved) {
            toast.warn("Please approve supplier to continue");
            return;
        }

        const license = {
            ...this.state.license,
            tillPriceCalculationMethod: value,
            applyCurrentPriceFromBarcodeOnUpdate: true
        };
        const updatedItemList = (license.itemList || []).map(item => this.calculateFields(item));
        const updatedLicense = {
            ...license,
            itemList: updatedItemList
        };

        this.setState({license: updatedLicense, loading: true});
        try {
            await this.saveLicenseToServer(updatedLicense, false);
        } finally {
            this.setState({loading: false});
        }
    }

    cancelCurrentPriceSelection = () => {
        this.setState(prevState => ({
            showCurrentPriceConfirmModal: false,
            pendingTillPriceCalculationMethod: null,
            tillPriceMethodSelectKey: (prevState.tillPriceMethodSelectKey || 0) + 1
        }));
    }

    _handleKeyDown = (e) => {
        if (e.target.name === 'barcode') {
            const allowedKeys = ['Backspace', 'Tab', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'Enter'];
            const isDigit = e.key.length === 1 && /[0-9]/.test(e.key);
            const isAllowedSpecial = allowedKeys.includes(e.key);
            const isShortcut = e.ctrlKey || e.metaKey;
            if (!isDigit && !isAllowedSpecial && !isShortcut) {
                e.preventDefault();
                return;
            }
        }
        if (e.key === 'Enter') {
            this.findByBarcode();
        }
    }

    searchProduct = (event) => {
        setTimeout(() => {
            this.productService.searchProductsByName(event.query).then(response => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.setState({filteredProducts: response});
                } else {
                    this.setState({filteredProducts: []});
                }


            });
        }, 250);
    }

    searchByBarcode = async (data) => {
        if (!GeneralUtils.isNullOrEmpty(data) && !GeneralUtils.isNullOrEmpty(data.barcode)) {
            try {
                const response = await this.productService.findProductByBarcodeWithDepos(data.barcode);

                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.refreshDepartmentListIfMissing(response.departmentId);
                    data = await this.convertProductDTOToItemDto(data, response);
                } else {
                    data.barcodeIsSearched = true;
                    data.itemBssId = null;
                    this.setState({}, () => {
                        //toast.warn("Barcode not Found");
                    });


                }
            } catch (error) {
                console.error("Barcode search error", error);
            }
        }
        return data;
    }


    findByBarcode() {
        if (!GeneralUtils.isNullOrEmpty(this.state.barcode)) {
            this.productService.findProductByBarcodeWithDepos(this.state.barcode)
                .then(async (response) => {

                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        this.refreshDepartmentListIfMissing(response.departmentId);
                        const data = await this.convertToDto(response);
                        this.updatePurchaseOrderItem(data);
                    } else {
                        this.setState({
                            barcode: '', selectedProduct: null, productId: null, productList: []
                        });
                        this.setState({}, () => {
                            //return toast.warn("Barcode not Found!");
                        });
                    }
                });
        }
        this.setState({barcode: ''});

    }

    refreshDepartmentListIfMissing = (departmentId) => {
        if (GeneralUtils.isNullOrEmpty(departmentId)) {
            return;
        }
        const exists = (this.state.departmentList || []).some((department) => department.id === departmentId);
        if (!exists) {
            this.departmentService.findAll().then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.setState({departmentList: response});
                }
            });
        }
    }

    importCsv(id) {
        let image = this.refUploadInputCsv.files;
        if (!(GeneralUtils.isNullOrEmpty(image) || GeneralUtils.isNullOrEmpty(image.length))) {
            this.setState({loading: true});
            let formData = new FormData();
            if (!GeneralUtils.isNullOrEmpty(image) && !GeneralUtils.isNullOrEmpty(image.length)) {
                formData.append("file", image[0]);
                this.purchaseOrderService.importCsv(id, formData).then(response => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        this.departmentService.findAll().then(responseDepartment => this.setState({departmentList: responseDepartment}));
                        if (this.refUploadInputCsv?.clear) {
                            this.refUploadInputCsv.clear();
                        }

                        let responseObject = Object.assign({}, response);
                        let responseObjectTemp = Object.assign({}, response);
                        this.setState({
                            //licenseSaveButtonRender: true,
                            license: responseObject,
                            loading: false,
                            licenseTemp: responseObjectTemp
                        }, () => {
                            this.setAllRowsEditable();
                        });

                    } else {
                        this.setState({
                            loading: false,
                        }, () => {
                        });
                    }

                });

            }
        } else {
            return toast.warn("Upload a csv file");
        }

    }

    renderSupplier() {
        return (
            <>
                <Col md="3">
                    <AvGroup>
                        <Label for="tradingName">
                            <Translate contentKey="productGroup.tradingName">Supplier</Translate>
                            <span style={{color: 'red'}}> (*)</span>
                        </Label>

                        <div style={{position: "relative"}}>
                            {/* Input */}
                            <AvField
                                type="text"
                                name="supplierName"
                                className="form-control"
                                style={{paddingRight: "90px"}} // ikonlar için sağ boşluk
                                disabled={this.state.license.invoiceType == "MANUAL_ENTRY" || this.state.license.invoiceType == "CSV" ? true : !this.state.licenseSaveButtonRender || this.state.license.supplierApproved || !GeneralUtils.isNullOrEmpty(this.state.license.supplierId)}
                                value={this.state.license.supplierName}
                                onChange={this.__handleChange}
                            />

                            {/* Iconlar */}
                            <div
                                style={{
                                    position: "absolute",
                                    right: "2px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    display: "flex",
                                    gap: "2px",
                                }}
                            >
                                {/* Search Icon */}
                                {!(!this.state.licenseSaveButtonRender || this.state.license.supplierApproved || !GeneralUtils.isNullOrEmpty(this.state.license.supplierId)) &&
                                    <i
                                        className="pi pi-search"
                                        style={{
                                            cursor: this.state.licenseSaveButtonRender ? "pointer" : "not-allowed",
                                            color: this.state.licenseSaveButtonRender ? "#000" : "#ccc",
                                        }}
                                        onClick={() => {
                                            if (!this.state.licenseSaveButtonRender) return;
                                            this.setState({displayDialogFilter: true});
                                        }}
                                    />
                                }


                                {/* Matched / Not Matched */}
                                {!GeneralUtils.isNullOrEmpty(this.state.license.supplierId) ? (
                                    <span
                                        style={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: "4px",
                                            padding: "2px 6px",
                                            borderRadius: "6px",
                                            backgroundColor: "#16A34A",
                                            color: "white",
                                            fontWeight: 600,
                                            fontSize: "12px",
                                        }}
                                    >
                                            <i className="pi pi-check" style={{cursor: "pointer", color: "white"}}/>
                                          </span>
                                ) : (
                                    <span
                                        className="blinking-badge"
                                        style={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: "4px",
                                            padding: "2px 6px",
                                            borderRadius: "6px",
                                            backgroundColor: "#DC2626",
                                            color: "white",
                                            fontWeight: 600,
                                            fontSize: "12px",
                                        }}
                                    >

                                        <span>NEW</span>
                                      </span>
                                )}

                            </div>


                        </div>

                        {this.state.license.purchaseOrderStatus != "CLOSED" &&  this.state.license.invoiceNumber != "ERROR" &&

                            !this.checkSupplierApproved() &&
                            <Button
                                color="outline-primary"
                                className="settings-page__btn--save settings-page__btn--wrap"
                                onClick={() => {
                                    let license = this.state.license;

                                    if (GeneralUtils.isNullOrEmpty(license.supplierName)
                                    ) {
                                        return toast.warn("Please fill the supplier field!");
                                    } else {
                                        this.purchaseOrderService.approveSupplierAndProcessAgain(license)
                                            .then((response) => {
                                                if (
                                                    !GeneralUtils.isNullOrEmpty(response) &&
                                                    GeneralUtils.isNullOrEmpty(response.type)
                                                ) {
                                                    this.setState({
                                                        license: response,
                                                        licenseTemp: response
                                                    }, () => {
                                                        this.setAllRowsEditable();
                                                    });
                                                }
                                            });
                                    }

                                }}
                            >
                                <Translate contentKey="entity.action.add">Approve Supplier</Translate>
                            </Button>
                        }
                    </AvGroup>
                </Col>

                <Col md="3">
                    <AvGroup>
                        <Label for="firstName">
                            <Translate contentKey="productfirstName">
                                Invoice Till Price Calculator
                            </Translate>
                        </Label>

                        <AvField
                            key={`till-price-calculation-${this.state.tillPriceMethodSelectKey}`}
                            type="select"
                            className="form-control"
                            name="tillPriceCalculationMethod"
                            disabled={
                                !(
                                    this.state.licenseSaveButtonRender &&
                                    this.state.license.purchaseOrderStatus !== "CLOSED" &&
                                    this.state.license.purchaseOrderStatus !== "PARTIAL_CLOSED"
                                )
                            }
                            value={this.state.license.tillPriceCalculationMethod || "NEAREST_9"}
                            onChange={this.__handleChange}
                        >
                            {INVOICE_TILL_PRICE_CALCULATION_METHOD.map(element => (
                                <option value={element.value} key={element.value}>
                                    {element.name}
                                </option>
                            ))}
                        </AvField>


                    </AvGroup>
                </Col>

                <Col md="3">

                    <AvGroup>
                        <Label for="mobilePhone">
                            <Translate contentKey="contactManagement.mobilePhone">Invoice Till User
                            </Translate>
                        </Label>

                        <AvField
                            type="select"
                            disabled={!(this.state.licenseSaveButtonRender && !GeneralUtils.isNullOrEmpty(this.state.license.id) && this.state.license.purchaseOrderStatus != "CLOSED" && this.state.license.purchaseOrderStatus != "PARTIAL_CLOSED")}
                            className="form-control"
                            name="printQueueTillUserBssId"
                            value={this.state.license.printQueueTillUserBssId}
                            onChange={this.__handleChange}>

                            <option value="" key=''>
                                Select
                            </option>
                            {this.state.tillUserList.map(element => (
                                <option value={element.bssId} key={element.bssId}>
                                    {element.name}
                                </option>))}
                        </AvField>

                    </AvGroup>
                </Col>


                <Col md="3">
                    <div className="d-flex align-items-center">

                        <AvGroup className="mb-0 d-flex align-items-center mr-3">
                            <Label className="mb-0 mr-2">
                                <Translate contentKey="productfirstName">Inc VAT&nbsp;</Translate>
                            </Label>

                            <Checkbox
                                onChange={(e) => this.setChecked("includeTax", e.checked)}
                                name="includeTax"
                                disabled={
                                    !(
                                        this.state.licenseSaveButtonRender &&
                                        this.state.license.purchaseOrderStatus !== "CLOSED" &&
                                        this.state.license.purchaseOrderStatus !== "PARTIAL_CLOSED"
                                    )
                                }
                                checked={this.state.license.includeTax}
                            />
                        </AvGroup>

                        <AvGroup className="mb-0 d-flex align-items-center">
                            <Label className="mb-0 mr-2">
                                <Translate contentKey="productfirstName">Use Invoice Barcode&nbsp;</Translate>
                            </Label>

                            <Checkbox
                                onChange={(e) => this.setChecked("useInvoiceBarcode", e.checked)}
                                name="useInvoiceBarcode"
                                disabled={
                                    !(
                                        this.state.licenseSaveButtonRender &&
                                        this.state.license.purchaseOrderStatus !== "CLOSED" &&
                                        this.state.license.purchaseOrderStatus !== "PARTIAL_CLOSED" &&
                                        !this.checkSupplierApproved()
                                    )
                                }
                                checked={this.state.license.useInvoiceBarcode}
                            />
                        </AvGroup>

                        <AvGroup className="mb-0 d-flex align-items-center ml-3">
                            <Label className="mb-0 mr-2">
                                <Translate contentKey="productfirstName">Ignore Box Quantity&nbsp;</Translate>
                            </Label>

                            <Checkbox
                                onChange={(e) => this.setChecked("readBoxQuantityFromProduct", e.checked)}
                                name="readBoxQuantityFromProduct"
                                disabled={
                                    !(
                                        this.state.licenseSaveButtonRender &&
                                        this.state.license.purchaseOrderStatus !== "CLOSED" &&
                                        this.state.license.purchaseOrderStatus !== "PARTIAL_CLOSED" &&
                                        !this.checkSupplierApproved()
                                    )
                                }
                                checked={this.state.license.readBoxQuantityFromProduct}
                            />
                        </AvGroup>

                    </div>
                </Col>





                <Col>
                    <Dialog
                        visible={this.state.displayDialogFilter}
                        header={"Supplier"}
                        onHide={() => this.setState({displayDialogFilter: false})}
                        style={GeneralUtils.getDialogStyleForSupplierFilter()}
                    >
                        <SupplierFilter
                            ref={(elem) => (this.refModelCredentialsSave = elem)}
                            onDataSelect={this.onDataSelectFilter}
                            closeDisplayDialog={this.closeDisplayDialogFilter}
                        />
                    </Dialog>
                </Col>
            </>
        );
    }


    closeDisplayDialogFilter = () => {
        this.setState({displayDialogFilter: false});
    }

    onDataSelectFilter = (data) => {
        let license = this.state.license;
        license["supplierId"] = data.id;
        license["supplierName"] = data.name;
        license["supplierBssId"] = data.bssId;
        license["supplierAccountCode"] = data.supplierAccountCode;
        license["supplierVatNumber"] = data.vatNumber;
        license["postcode"] = data.postcode;
        license["supplierPhoneNumber"] = data.phone;


        this.setState({
            license: license,
            displayDialogFilter: false
        }, () => {

        });


    }

    generatePurchaseOrderItemFields(departmentList = []) {
        const rowNoColumn = {
            field: '_rowNo',
            header: '#',
            visible: true,
            editable: false,
            style: { width: '20px', textAlign: 'center' },
            headerStyle: { width: '20px', textAlign: 'center' }
        };

        let fields = cloneDeep(
            GeneralUtils.isMobile()
                ? PurchaseOrderItemMobileColumn.fields
                : PurchaseOrderItemColumn.fields
        );
        fields.unshift(rowNoColumn);

        let enableDesktopScroll = false;

        if (!GeneralUtils.isMobile()) {
            const purchaseOrderItemListFields = this.state.purchaseOrderItemListFields;

            if (purchaseOrderItemListFields && purchaseOrderItemListFields.length > 0) {
                enableDesktopScroll = true;
                 fields = cloneDeep(
                        PurchaseOrderItemResizableColumn.fields
                );
                fields.unshift(rowNoColumn);
                fields = fields.map(f => ({
                    ...f,
                    visible: f.field === '_rowNo' || f.field?.startsWith('button.') || f.field?.startsWith('badge.')
                        ? true
                        : purchaseOrderItemListFields.includes(f.field)
                }));
            }
        }

        const width = window.innerWidth;

        fields = fields.map(f => {
            if (f.maxWidthVisible && width < f.maxWidthVisible) return { ...f, visible: false };
            if (f.minWidthVisible && width > f.minWidthVisible) return { ...f, visible: false };
            return f;
        });

        const departmentField = fields.find(f => f.field === 'departmentId');
        if (departmentField) {
            departmentField.dataElement = departmentList.reduce((acc, dept) => {
                acc[dept.id] = dept.name;
                return acc;
            }, {});
        }

        const tillCalcMethodItemField = fields.find(
            f => f.field === 'tillPriceCalculationMethod'
        );
        if (tillCalcMethodItemField) {
            tillCalcMethodItemField.dataElement = TILL_PRICE_ITEM_CALCULATION_METHOD.reduce(
                (acc, el) => {
                    acc[el.value] = el.name;
                    return acc;
                },
                {}
            );
        }
        if (this.state.desktopScroll !== enableDesktopScroll) {
            this.setState({ desktopScroll: enableDesktopScroll });
        }

        return fields;
    }


    calculateFields = (product, field) => {
        try {
            const newProduct = {...product};
            const HUNDRED = new Decimal(100);

            if (field === "barcode") {
                newProduct['ItemBssId'] = null;
                newProduct['barcodeIsSearched'] = false;
            }

            newProduct['recommendedSalePrice'] = null;
            newProduct['actualMargin'] = null;
            newProduct['unitCost'] = null;
            newProduct['costPrice'] = null;
            newProduct['taxPrice'] = null;

            if (GeneralUtils.isNullOrEmpty(newProduct['barcode'])) {
                newProduct['itemBssId'] = null;
            }

            const boxQty = new Decimal(newProduct.boxSize || 1);
            const deliveryQuantity = new Decimal(newProduct.deliveryQuantity || 1);
            const totalPrice = new Decimal(newProduct.totalPrice || 0.0);
            const profitMargin = new Decimal(newProduct.profitMargin || 0.0);
            const vatRate = new Decimal(newProduct.taxRate || 0.0);

            // boxPrice = totalPrice / deliveryQuantity
            const boxPrice = deliveryQuantity.isZero()
                ? new Decimal(0)
                : totalPrice.div(deliveryQuantity).toDecimalPlaces(6);

            newProduct['boxPrice'] = parseFloat(
                boxPrice.toDecimalPlaces(2, Decimal.ROUND_HALF_UP).toString()
            );

            // Cur. Unit Cost - hesaplanan alan (currentBoxPrice / currentBoxSize veya boxSize)
            const divisorForUnitCost = newProduct.currentBoxSize ?? newProduct.boxSize;
            if (
                newProduct.currentBoxPrice != null &&
                divisorForUnitCost != null &&
                Number(divisorForUnitCost) !== 0
            ) {

                newProduct.currentUnitCost = parseFloat(
                    new Decimal(newProduct.currentBoxPrice)
                        .div(new Decimal(divisorForUnitCost))
                        .toDecimalPlaces(2, Decimal.ROUND_HALF_UP)
                        .toString()
                );
            } else {
                newProduct.currentUnitCost = null;
            }

            let unitCost;
            if (boxPrice == null || boxQty == null || boxQty.isZero()) {
                unitCost = new Decimal(0);
            } else {
                unitCost = boxPrice
                    .div(boxQty)
                    .toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
            }

            newProduct['unitCost'] = parseFloat(unitCost.toString());

            let costPrice = new Decimal(0);
            let taxPrice = new Decimal(0);

            if (this.state.license?.includeTax) {
                costPrice = unitCost.toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
                if (!costPrice.isZero() && !vatRate.isZero()) {
                    taxPrice = costPrice.times(vatRate)
                        .div(HUNDRED.plus(vatRate))
                        .times(deliveryQuantity)
                        .times(boxQty)
                        .toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
                } else {
                    taxPrice = new Decimal(0);
                }
            } else {
                const vatMultiplierPrecise = vatRate.plus(HUNDRED).div(HUNDRED).toDecimalPlaces(6);
                if (unitCost.isZero()) {
                    costPrice = new Decimal(0);
                    taxPrice = new Decimal(0);
                } else {
                    costPrice = unitCost.times(vatMultiplierPrecise).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
                    taxPrice = costPrice.minus(unitCost)
                        .times(deliveryQuantity)
                        .times(boxQty)
                        .toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
                }
            }

            newProduct['costPrice'] = parseFloat(costPrice.toString());
            newProduct['taxPrice'] = parseFloat(taxPrice.toString());

            const marginMultiplier = profitMargin.plus(HUNDRED).div(HUNDRED);
            let recommendedSalePrice = costPrice.times(marginMultiplier).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);

            const method =
                newProduct.tillPriceCalculationMethod && newProduct.tillPriceCalculationMethod.trim() !== ""
                    ? newProduct.tillPriceCalculationMethod
                    : this.state.license?.tillPriceCalculationMethod;

            if (method) {
                switch (method) {
                    case "NEAREST_9":
                        recommendedSalePrice = CalculationUtils.roundNearest9(recommendedSalePrice);
                        break;
                    case "NEAREST_49_99":
                        recommendedSalePrice = CalculationUtils.roundNearest49_99(recommendedSalePrice);
                        break;
                    case "NEAREST_00":
                        recommendedSalePrice = CalculationUtils.roundNearest00(recommendedSalePrice);
                        break;
                    case "NEAREST_50":
                        recommendedSalePrice = CalculationUtils.roundNearest50(recommendedSalePrice);
                        break;
                    case "CURRENT_PRICE":
                        if (!GeneralUtils.isNullOrEmpty(newProduct.oldPrice)) {
                            recommendedSalePrice = new Decimal(newProduct.oldPrice);
                        }
                        break;
                }
            }

            newProduct['recommendedSalePrice'] = parseFloat(recommendedSalePrice.toString());

            if (method !== "PRICE_MARK" && method !== "MANUAL_ENTRY") {
                if (method === "CURRENT_PRICE") {
                    if (!GeneralUtils.isNullOrEmpty(newProduct.oldPrice)) {
                        newProduct['salePrice'] = parseFloat(new Decimal(newProduct.oldPrice).toString());
                    } else {
                        newProduct['salePrice'] = parseFloat(recommendedSalePrice.toString());
                    }
                } else if (newProduct.oldPrice != null && recommendedSalePrice < newProduct.oldPrice) {
                    newProduct['salePrice'] = newProduct.oldPrice;
                } else if (
                    newProduct.oldPrice != null &&
                    newProduct.oldPrice !== 0 &&
                    newProduct.currentUnitCost != null &&
                    newProduct.currentUnitCost !== 0 &&
                    newProduct.unitCost != null &&
                    newProduct.unitCost !== 0 &&
                    new Decimal(newProduct.currentUnitCost)
                        .minus(new Decimal(newProduct.unitCost))
                        .abs()
                        .lte(
                            new Decimal(newProduct.currentUnitCost)
                                .abs()
                                .times(new Decimal(this.state.defaultCostPricePercentage ?? 0))
                                .div(HUNDRED)
                        )
                ) {
                    // currentActualMargin: eski fiyat / Cur. Unit Cost
                    const currentActualMargin = new Decimal(newProduct.oldPrice)
                        .div(new Decimal(newProduct.currentUnitCost))
                        .times(HUNDRED)
                        .minus(HUNDRED)
                        .toDecimalPlaces(2, Decimal.ROUND_HALF_UP);

                    // newActualMargin: yeni fiyat / Unit Cost
                    const newActualMargin = recommendedSalePrice
                        .div(new Decimal(newProduct.unitCost))
                        .times(HUNDRED)
                        .minus(HUNDRED)
                        .toDecimalPlaces(2, Decimal.ROUND_HALF_UP);

                    // tolerans: mevcut marjın ±%10'u (örn. 40 → 36–44, 50 → 45–55)
                    const tolerance = currentActualMargin.abs().times(0.10);
                    const diff = newActualMargin.minus(currentActualMargin).abs();

                    if (diff.lte(tolerance)) {
                        newProduct['salePrice'] = newProduct.oldPrice;
                    } else {
                        newProduct['salePrice'] = parseFloat(recommendedSalePrice.toString());
                    }
                } else {
                    newProduct['salePrice'] = parseFloat(recommendedSalePrice.toString());
                }
            }

            const itemPrice = new Decimal(newProduct.salePrice || 0.0);
            if (!costPrice.isZero()) {
                newProduct['actualMargin'] = parseFloat(
                    itemPrice.div(costPrice).times(HUNDRED).minus(HUNDRED)
                        .toDecimalPlaces(2, Decimal.ROUND_HALF_UP).toString()
                );
                if (newProduct.salePrice === newProduct.recommendedSalePrice) {
                    newProduct['actualMargin'] = newProduct.profitMargin;
                }
            } else {
                newProduct['actualMargin'] = 0;
            }

            const profit = (new Decimal(newProduct.salePrice || 0))
                .minus(unitCost)
                .toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
            newProduct['profit'] = parseFloat(profit.toString());

            const totalProfit = profit
                .times(new Decimal(newProduct.deliveryQuantity || 0))
                .times(new Decimal(newProduct.boxSize || 0))
                .toDecimalPlaces(2, Decimal.ROUND_HALF_UP);

            newProduct['totalProfit'] = parseFloat(totalProfit.toString());

            newProduct['newStock'] =
                (newProduct.deliveryQuantity || 0) * (newProduct.boxSize || 0);

            return newProduct;

        } catch (e) {
            console.error("calculateFields error:", e);
            return {...product};
        }

    }
}

PurchaseOrderSave.propTypes =
    {
        license: PropTypes.object
    }
;
